import { cn } from '@/utils';

interface BrandLogoProps {
  /** `dark` = white wordmark for navy surfaces, `light` = navy wordmark for white surfaces. */
  variant?: 'dark' | 'light';
  /** Crown only, for collapsed navigation. */
  compact?: boolean;
  className?: string;
}

const LOGO_SRC = {
  dark: '/images/logo/krown1x.svg',
  light: '/images/logo/krown1x-light.svg',
} as const;

export function BrandLogo({ variant = 'dark', compact = false, className }: BrandLogoProps) {
  const classes = cn('h-9 w-auto', className);

  if (compact) return <img src="/favicon/favicon.svg" alt="KROWN1X" className={classes} />;

  // The navy wordmark disappears on dark surfaces, so the light variant swaps to white in dark theme.
  if (variant === 'light') {
    return (
      <>
        <img src={LOGO_SRC.light} alt="KROWN1X" className={cn(classes, 'dark:hidden')} />
        <img src={LOGO_SRC.dark} alt="KROWN1X" className={cn(classes, 'hidden dark:block')} />
      </>
    );
  }

  return <img src={LOGO_SRC.dark} alt="KROWN1X" className={classes} />;
}
